import { ApiQueryConfig } from 'api/types';
import { URLS } from 'config';
import { createApiEndpoint } from '../utils';
import { ServiceValues } from './types';

type GetServiceConfigurationQueryParams = { show?: boolean };
type GetServiceConfigurationConfig = ApiQueryConfig<
  ServiceValues,
  { $serviceConfigId: number },
  GetServiceConfigurationQueryParams
>;

export const getServiceConfiguration =
  createApiEndpoint<GetServiceConfigurationConfig>({
    url: `${URLS.app}/api/ServiceConfigurations/$serviceConfigId/v2`,
    method: 'GET',
  });
